import $ from 'jquery';
/***
 Toggle class on hover to allow for fade non-active items
*/
$('.js--faded-hoverItem img').hover(function () {
    $('.js--faded-hoverContainer').toggleClass('js--hover-fade');
    $(this).toggleClass('js--hover-fade-item');
});

$('.js--faded-hoverItem .card-body').hover(function () {
    $('.js--faded-hoverContainer').toggleClass('js--hover-fade');
    $(this).parent('a').find('img').toggleClass('js--hover-fade-item');
});